<template>
  <page :setup="setup">
    <div class="main-content">
      <fin-form
        ref="form"
        :defaultData="defaultParam"
        :formData="formData"
        :backend="true"
        theme="light"
        @landChange="landChange"
        @reset="reset"
        @save="save"
      ></fin-form>
    </div>
  </page>
</template>

<script>
const ARR_KEY = {
  incomeTaxRate: 'incomeTaxType',
  maintainData: 'maintainNum',
  insureData: 'insureNum',
  materialConsumption: 'materialNum',
  otherFee1: 'otherFeeNum',
  otherFee2: 'otherFeeNum',
  depreciableData: 'depreciableType'
};
const ARR_KEY_VALUE = {
  depreciableData: 2
};
const ARR_KEY_POSTFIX = {
  energyData: '_Arr',
  totalInvestArr: '_Arr',
  energyDataArr: '_Arr',
  priceWithArr: '_Arr',
  loanInterestRateArr: '_Arr'
};

export default {
  data() {
    return {
      mainContent: 'main-form',
      currentTab: 'relate',
      readonly: false,
      selectEcos: [],
      formData: {},
      currentEco: null,
      relateSearch: '',
      unrelateSearch: '',
      relateData: [],
      unrelateData: [],
      formArrKey: [
        'constructionInvest',
        'otherAssets',
        'immaterialAssets',
        'incomeTaxRate',
        'maintainData',
        'insureData',
        'materialConsumption',
        'otherFee1',
        'otherFee2',
        'ongridCapacity',
        'staffCapacity',
        'staffSalary',
        'welfareRate',
        'depreciableData',
        'energyData',
        'totalInvestArr',
        'energyDataArr',
        'priceWithArr',
        'loanInterestRateArr'
      ]
    };
  },
  methods: {
    async setup() {
      await this.fetchDefaultParam(1);
      this.reset();
    },
    async landChange(landOrSea) {
      await this.fetchDefaultParam(landOrSea, true);
      this.formData = { ...this.defaultParam, name: this.formData.name };
      //console.log('current form', this.formData);
    },
    async fetchDefaultParam(landOrSea, showLoading) {
      const res = await this.$fetch({
        url: '/windfarm/economic/getDefaultParam',
        params: {
          landOrSea
        },
        showLoading
      });
      this.defaultParam = this.prefixParam(res.data.defaultParam);
    },
    prefixParam(data) {
      const formData = { ...data };
      this.formArrKey.forEach(key => {
        const value = formData[key];
        formData[`${key}${ARR_KEY_POSTFIX[key] || 'Arr'}`] =
          typeof value === 'string' ? value.split(',') : [];
      });
      return formData;
    },
    async save() {
      try {
        const data = {
          ...this.formData,
          economicId: this.defaultParam ? this.defaultParam.economicId : 0,
          whetherLcoe: 1
        };
        this.formArrKey.forEach(key => {
          const arrKey = `${key}${ARR_KEY_POSTFIX[key] || 'Arr'}`;
          if (ARR_KEY[key]) {
            if (+data[ARR_KEY[key]] === (ARR_KEY_VALUE[key] || 1)) {
              const value = data[arrKey];
              data[key] = value.join(',');
            }
          } else {
            data[key] = data[arrKey].join(',');
          }
          data[arrKey] = null;
        });
        if (data.constructionStarttime?.indexOf('-01') === -1) {
          data.constructionStarttime += '-01';
        }
        console.log('before submit', data);
        const res = await this.$fetch({
          module: 'manage',
          url: '/manage/economic/saveEconomicPlan',
          data,
          method: 'post',
          showError: true,
          showLoading: true,
          showSuccess: true
        });
        console.log('res', res);
      } catch (e) {
        console.log('submit err', e);
      }
    },
    reset() {
      this.formData = { ...this.defaultParam };
      //console.log('current form', this.formData);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.main-content {
  color: #fff;
  height: 100%;

  .fin-form {
    .el-input__inner {
      color: #000;
      border-radius: 0px;
      background-color: transparent;
    }

    .el-select {
      .el-input {
        &.is-disabled {
          .el-input__inner:read-only {
            border: 0;
          }

          .el-input__suffix {
            display: none;
          }
        }

        .el-input__inner:read-only {
          border: 1px solid #e4e7ed;
        }
      }
    }

    .el-input-group__append {
      border-radius: 0px;

      .el-button {
        background-color: #fff !important;
        color: #ccc !important;
      }
    }
  }
}
</style>
